import RouterLink from "../../../Link/RouterLink";
import "./TrainingsArticle.css";

type TrainingProgramModel = {
  intro: string;
  points: Array<string>;
};

type TrainingRateModel = {
  price: number;
  title: string;
  description: string;
};

type TrainingResumeModel = {
  title: string;
  lowContent: string;
  bigContent: string;
};

type TrainingTypeModel = "formation" | "supervision" | "service-entreprises";

type TrainingModel = {
  id: number;
  title: string;
  description: string;
  type: TrainingTypeModel;
  thumbnail: string;
  imgTraining: string;
  program: TrainingProgramModel;
  public: string;
  participants: string;
  duration: string;
  rates: Array<TrainingRateModel>;
  resume: TrainingResumeModel;
  photos: Array<string>;
};

interface TrainingsArticleProps {
  training: TrainingModel;
  index: number;
}

const routeByTrainingType = {
  formation: "formation",
  supervision: "supervision",
  "service-entreprises": "service-entreprises",
};

function TrainingsArticle(props: TrainingsArticleProps) {
  return (
    <article className="training-article" data-article={props.index}>
      <picture className="training-article-img">
        <source
          srcSet={`${process.env.REACT_APP_DOMAIN}Imgs/${props.training?.thumbnail}`}
        />
        <img
          src={`${process.env.REACT_APP_DOMAIN}Imgs/${props.training?.thumbnail}`}
          alt=""
        />
      </picture>
      <div className="training-article-content">
        <h3 className="training-article-title">{props.training?.title}</h3>
        <p className="training-article-description">
          {props.training?.description}
        </p>
        <RouterLink
          to={`/${routeByTrainingType[props.training.type]}/${
            props.training.id
          }`}
          className="training-article-btn"
        >
          En savoir plus
        </RouterLink>
      </div>
    </article>
  );
}

export default TrainingsArticle;
